module.exports = {
          srcSet: __webpack_public_path__ + "public/images/4f9178c9e3a32656a8cd0f910148628a-1200.webp"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/4f9178c9e3a32656a8cd0f910148628a-1200.webp",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/4f9178c9e3a32656a8cd0f910148628a-1200.webp",
          toString:function(){return __webpack_public_path__ + "public/images/4f9178c9e3a32656a8cd0f910148628a-1200.webp"},
          
          width: 1200,
          height: 800
        }